import {
  View,
  StyleSheet,
  TouchableOpacity,
  Text,
  ActivityIndicator,
  Pressable,
} from "react-native";
import React from "react";
import ReactModal from "react-modal";
import { createArrayOfNumberProvided } from "../../utils/array.utils";
import {
  startValueForX,
  startValueForY,
} from "../../utils/fieldCoordinateMapping.utils";

const ZoomedField = ({
  isVisible,
  onClose = () => null,
  props,
  rows,
  columns,
}) => {
  return (
    <ReactModal
      isOpen={isVisible}
      shouldCloseOnOverlayClick={true}
      onRequestClose={() => onClose()}
      style={{
        zIndex: 2,
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backdropFilter: "blur(5px)",
        },
        content: {
          backgroundColor: "#fff",
          //   width: "58rem",
          //   height: "48rem",
          border: "none",
          inset: "auto",
          padding: "1rem",
          display: "flex",
          alignItems: "center",
          justifyItems: "center",
          justifyContent: "center",
          borderRadius: "0.4rem",
        },
      }}
    >
      <View
        style={{
          width: "100%",
          height: "100%",
          zIndex: 4,
          display: "flex",
          flexDirection: "column",
          //   borderColor: "#2699fb30",
          //   borderWidth: "0.2rem",
          //   borderRadius: "0.2rem",
        }}
      >
        <Text
          style={{
            textAlign: "center",
            marginBottom: "1rem",
            fontSize: "1rem",
            color: "#1d1d1d",
            fontWeight: "600",
          }}
        >
          Select inside block {props.x + "" + props.y}
        </Text>
        <div
          style={{
            width: "100%",
          }}
        >
          {createArrayOfNumberProvided(rows + 1).map((y, index1) => (
            <View
              key={index1}
              style={{
                flexDirection: "row",
                width: "100%",
                height: "20%",
              }}
            >
              {createArrayOfNumberProvided(columns + 1).map((x, index11) => {
                let xpos = x + 1;
                let ypos = y + 1;
                return (
                  <View
                    key={index11}
                    style={{
                      width: "4rem",
                      height: "4rem",
                      justifyContent: "center",
                      alignItems: "center",
                      zIndex: 10,
                    }}
                  >
                    <UnitBox
                      rows={rows}
                      columns={columns}
                      x={xpos}
                      y={ypos}
                      o_x={props.x}
                      o_y={props.y}
                      onPress={({ x, y }) => {
                        props.onPress({ x, y });
                        onClose();
                      }}
                    />
                  </View>
                );
              })}
            </View>
          ))}
        </div>
      </View>
    </ReactModal>
  );
};

const UnitBox = (props) => {
  var x =
    props.o_y === 0 ? startValueForX[props.o_x] : startValueForX[props.o_x + 1];
  var y = startValueForY[props.o_y];
  return (
    <TouchableOpacity
      onPress={() => {
        props.onPress({ x: y + props.x, y: x + props.y });
      }}
      style={[
        styles.unitBoxContainer,
        // { outline: "none" },
        // props.y !== 0 &&
        //   props.x % 2 === 0 &&
        //   (props.x + "" + props.y) % 2 === 0 && {
        //     backgroundColor: "#2699fb30",
        //   },
        // ,
        // props.x % 2 !== 0 &&
        //   (props.x + "" + props.y) % 2 !== 0 && {
        //     backgroundColor: "#2699fb30",
        //   },
        // props.x % 2 !== 0 && props.y === 0 && { backgroundColor: "#2699fb30" },
      ]}
    >
      <View
        style={{
          height: "15%",
          width: "15%",
          borderRadius: "50%",
          backgroundColor: "#2699fb",
        }}
      ></View>
      <Text
        style={{
          fontSize: 12,
          fontWeight: "700",
          color: "#2699fb",
          //   padding: "2rem 2rem",
        }}
      >
        {/* {props.x + " , " + props.y} */}
        {y + props.x + " , " + (x + props.y)}
      </Text>
    </TouchableOpacity>
  );
};

export default ZoomedField;

const styles = StyleSheet.create({
  unitBoxContainer: {
    flex: 1,
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
});
